import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { ManagerWithPMC } from "./ManagerWithPMC";
import { ManagerWithoutPMC } from "./ManagerWithoutPMC";
import type { StripeElementsManagerProps } from "./Props";

export const StripeElementsManager = ({
  children,
}: StripeElementsManagerProps) => {
  const { currentCommunityProcessorPaymentMethodConfigurationId } =
    usePaywallCheckoutContext();

  let Manager;
  if (currentCommunityProcessorPaymentMethodConfigurationId) {
    Manager = ManagerWithPMC;
  } else {
    Manager = ManagerWithoutPMC;
  }

  return <Manager>{children}</Manager>;
};
